import { isEmpty, isNil } from 'lodash'
import shortUUID from 'short-uuid'
import { v4 as uuidv4 } from 'uuid'
import cookie from './cookie'

export const getDeviceId = (): string => {
  let deviceId = cookie.deviceId.get()

  if (isNil(deviceId) || isEmpty(deviceId)) {
    deviceId = uuidv4()
    cookie.deviceId.set(deviceId)
  }

  return deviceId.toString()
}
